const FORMAT = /^(29|3[0-9]|40)$/

module.exports = function() {
  return value => {
    if (!value || !FORMAT.test(value)) return false
    return true
  }
}
